import {
  AdjustFeatures,
  AdjustTerms,
  ToolkitStudyV1Request,
  adjustTermToFeature,
  toTitleCase,
} from '@aloft/toolkit-shared';

import { isPairedSalesCustomAnalysisFeature } from '../../adjustPairedSalesStandalone/utils/isPairedSalesCustomAnalysisFeature.ts';

function getPrefix(analysisFeature: ToolkitStudyV1Request['analysisFeature']): string {
  if (analysisFeature === 'totalBasementArea') {
    return 'Basement';
  } else if (analysisFeature === 'carportParkingSpacesCount') {
    return 'Carport ';
  } else if (analysisFeature === 'garageParkingSpacesCount') {
    return 'Garage ';
  } else if (analysisFeature === 'grossLivingArea') {
    return 'GLA';
  } else if (analysisFeature === 'site') {
    return 'Lot';
  }

  return '';
}

export function getAnalysisFeatureUnitString(
  analysisFeature: ToolkitStudyV1Request['analysisFeature'],
): string {
  if (isPairedSalesCustomAnalysisFeature(analysisFeature)) {
    return analysisFeature.name;
  }

  const feature = adjustTermToFeature(analysisFeature);
  const unit =
    (feature && AdjustFeatures[feature].unit) ?? AdjustTerms[analysisFeature].label ?? 'unit';
  const prefix = getPrefix(analysisFeature);

  if (
    analysisFeature === 'totalBasementArea' ||
    analysisFeature === 'grossLivingArea' ||
    analysisFeature === 'site'
  ) {
    return `${toTitleCase(unit)} ${prefix}`;
  }

  return toTitleCase(`${prefix}${unit}`);
}
